import { Signature, SignatureReason } from '../models/signatures';

export const SVG_DATA_URL_PREFIX = 'data:image/svg+xml,';
export const PNG_DATA_URL_PREFIX = 'data:image/png;base64,';

/**
 * Converts a signature to a data URL preferring the SVG over the image.
 */
export const getSignatureSource = (signature: Signature | null | undefined): string | null => {
  if (!signature) return null;
  if (signature.data_svg) return `${SVG_DATA_URL_PREFIX}${signature.data_svg}`;
  if (signature.data_image) return `${PNG_DATA_URL_PREFIX}${signature.data_image}`;

  return null;
};

/**
 * Finds a signature by its reason. Chooses the first one found, null otherwise.
 */
export const getSignature = (
  signatures: Signature[] | null | undefined,
  reason: SignatureReason,
): Signature | null => {
  return signatures?.find(signature => signature.subtype === reason) ?? null;
};


